import envConfig from '@hulu/env-config';
import { useLocation, useNavigate, useSearchParams } from '@hulu/react-router-dom';
import { Auth } from 'aws-amplify';
import { useContext, useEffect } from 'react';

import { RedirectParam, RoutePath } from '../../constants';
import { GhostModeContext } from '../../context/GhostMode/GhostMode';
import { UserInfo } from '../../models/UserAWSCognitoInfo';
import { User } from '../../utils/user';
import { isOrgSwitcherRedirectAllowed } from './utils';

export type UnauthorizedRouteProps = {
  children: JSX.Element;
};

export const UnauthorizedRoute = ({ children }: UnauthorizedRouteProps): JSX.Element | null => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAuthEnabled = envConfig.REACT_APP_AUTH_FEATURE_ENABLED === 'true';
  const { isGhostMode } = useContext(GhostModeContext);
  const [searchParams] = useSearchParams();

  const redirectToOrgSwitcherAllowed = isOrgSwitcherRedirectAllowed(searchParams, pathname);

  useEffect(() => {
    if (isGhostMode && User.getUserInfo().idToken) {
      window.open(`${window.location.origin}${RoutePath.ACCOUNT}/profile`, '_self');
    }
  }, [isGhostMode]);

  useEffect(() => {
    if (redirectToOrgSwitcherAllowed) {
      Auth.currentSession()
        .then((session) => {
          if (session.isValid()) {
            const user = session.getIdToken().decodePayload() as UserInfo;
            const redirectOther = searchParams.get(RedirectParam.redirectOther);

            if (redirectToOrgSwitcherAllowed && redirectOther) {
              window.location.replace(redirectOther);
              return;
            }

            if (!isAuthEnabled || user?.ams_user_id) {
              navigate(RoutePath.ORG_SWITCHER);
            }
          }
        })
        .catch(() => void 0);
    }
  }, [isAuthEnabled, navigate, redirectToOrgSwitcherAllowed]);

  if (isGhostMode && User.getUserInfo().idToken) {
    return null;
  }

  return children;
};
